import { render, staticRenderFns } from "./ProviderProfileCard.vue?vue&type=template&id=6075403a&"
import script from "./ProviderProfileCard.vue?vue&type=script&lang=js&"
export * from "./ProviderProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./ProviderProfileCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports